"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagBZ = function FlagBZ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-93.75H-193v-21.19a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,118.11H216.6V139.3a7.07,7.07,0,0,1-7.06,7.06H-185.94A7.07,7.07,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "29.25",
    width: "409.6",
    height: "211.86",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M103.61,12.18A91.81,91.81,0,1,1,11.8-79.63a91.82,91.82,0,0,1,91.81,91.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5.82,60.45-20,62.82a2.93,2.93,0,0,1-3.41-2.89V54.6H-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.33,60.45l14.16,2.37a2.93,2.93,0,0,0,3.41-2.89V54.6H29.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.83-34.82H7.6a3.82,3.82,0,0,1-3.44-2.13L2-41.29l2-1,2.17,4.33A1.64,1.64,0,0,0,7.6-37H8.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.86-39.35l3.63,7.26-2,1-3.63-7.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.79-1l-6-6a7.08,7.08,0,0,1-2-5v-2a4.89,4.89,0,0,0-.51-2.15l-1.49-3a1.84,1.84,0,0,0-1.64-1H-1.08a4,4,0,0,1-3.6-2.23L-6.8-26.65l2-1,2.11,4.24a1.85,1.85,0,0,0,1.64,1H4.09a4,4,0,0,1,3.6,2.23l1.5,3A7.09,7.09,0,0,1,9.93-14v2a4.81,4.81,0,0,0,1.41,3.4l2.25,2.25V-16.59a12.34,12.34,0,0,0-2.69-7.66,14.51,14.51,0,0,1-3.17-9v-8.49h2.2v8.49a12.29,12.29,0,0,0,2.69,7.67,14.52,14.52,0,0,1,3.17,9Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.56-6.73H7.3A4.85,4.85,0,0,1,2.77-9.88l-.83-2.23L4-12.87l.82,2.22A2.66,2.66,0,0,0,7.3-8.93h3.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.55-45.15l2,.89L9.2-16.23l-2-.88Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.57-20.18H14v-2.2h8.43V-33h2.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.43-9.56H-4.35a4.4,4.4,0,0,1-4.4-4.39,4.4,4.4,0,0,1,4.4-4.4H4.43a4.4,4.4,0,0,1,4.4,4.4,4.4,4.4,0,0,1-4.4,4.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.94-9.56H16.15a4.39,4.39,0,0,1-4.39-4.39,4.39,4.39,0,0,1,4.39-4.4h8.79a4.4,4.4,0,0,1,4.39,4.4,4.4,4.4,0,0,1-4.39,4.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.72-18.35H22a4.39,4.39,0,0,1-4.4-4.39A4.39,4.39,0,0,1,22-27.13H33.72a4.39,4.39,0,0,1,4.4,4.39,4.39,4.39,0,0,1-4.4,4.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.65-30.06H16.15a4.39,4.39,0,0,1-4.39-4.4,4.39,4.39,0,0,1,4.39-4.39h20.5a4.4,4.4,0,0,1,4.4,4.39,4.4,4.4,0,0,1-4.4,4.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.94-41.78H19.08a4.39,4.39,0,0,1-4.39-4.39,4.39,4.39,0,0,1,4.39-4.4h5.86a4.4,4.4,0,0,1,4.39,4.4,4.4,4.4,0,0,1-4.39,4.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.14-35.92h-2.93a4.4,4.4,0,0,1-4.39-4.39,4.39,4.39,0,0,1,4.39-4.4h2.93a4.39,4.39,0,0,1,4.39,4.4,4.39,4.39,0,0,1-4.39,4.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.36-38.85H-1.42a4.4,4.4,0,0,1-4.4-4.39,4.4,4.4,0,0,1,4.4-4.4H7.36a4.4,4.4,0,0,1,4.4,4.4,4.4,4.4,0,0,1-4.4,4.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.43-24.21H-13.14a4.38,4.38,0,0,1-4.39-4.39A4.38,4.38,0,0,1-13.14-33H4.43a4.39,4.39,0,0,1,4.4,4.39,4.39,4.39,0,0,1-4.4,4.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M55.69,37H-32.18A5.86,5.86,0,0,0-38,42.88a5.86,5.86,0,0,0,5.86,5.86H-8.75A5.87,5.87,0,0,0-2.89,54.6H26.4a5.86,5.86,0,0,0,5.86-5.86H55.69a5.86,5.86,0,0,0,0-11.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M70.15-15c-.22-.43-1.36.09-2.08-.18-8.84-3.28-20.72-9.28-28.49-13.36L38-31,23.3-38.13a2,2,0,0,0-2.57.8L20-36.06a2,2,0,0,0,.8,2.73l14,7.29,4-.29,15.39,7.91s10.46,5.35,11,5.74.87,2.6,1.91,2.41c.74-.13,4-2.79,3.05-4.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#be7855"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-26.93,41.42s1,4.33.06,4.82-5.79.49-5.67-.55.79-4.7.79-4.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe3c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-18.81,39.1s-.79,3.23.79,3.35,10.56.06,10.8-.18a4,4,0,0,0,.55-.85L-15,39.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe3c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27.92-1.24S-30.1,4-30.9,21.92c-.21,4.78.37,3.66-2,19l2.82,1.47a2.67,2.67,0,0,0,2.61-.08l2.75-1.66s-1.34-17.21,3.05-27.1c0,0,2.32,4.28,2.32,7.45s-.12,18.42-.12,18.42a40.18,40.18,0,0,0,7.44.61S-13.5,7-15-.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#eaf3f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27.51-3.43a1.93,1.93,0,0,0-.41,2.19s6.68,2.89,13,.42a2,2,0,0,0-.18-2.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-36.45-19.3c-3.8,1.42-9.58,5-9.21,7.75s2.35,2.13,3,1.44a43.91,43.91,0,0,1,3-3.3c.56-.39,9.55-5,9.55-5L-6.36-30.66A2.36,2.36,0,0,0-7.6-32.81,236.89,236.89,0,0,1-36.45-19.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-25.22-33.09l-.14,1s-.37,6.46,1.74,8.19c0,0,.46,1.33-.28,2s-8,4.3-8,4.3-1.87,3.89-1.83,6.09c0,0-1.78-.69-1.6-1.56s1.23-3.15.91-4.25a1.2,1.2,0,0,0-1.5-.78s-.6.64.36,1.05l-.32,1.37-3.89,2.29.87,1.05s0,8.06,4.8,9.11c0,0,2.52.18,5.5-5.49,0,0,1.6,2.84,1,5.31a16.19,16.19,0,0,0,12.35.36l.1-4.94S-14-.41-10.21-1.15c0,0,10.39-4,8.66-5.52-4-3.54-8.89-.55-8.89-.55-.24-5.14-.67-11.78-1.33-12.5-1.1-1.19-4.48-.55-5.16-2.08s-.48-4.21.25-7.32-3-5.31-3-5.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe3c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-25.36-32.08s3.74.95,6.67-.21l1.28,3.17h.73s1.77-5.87-.58-5.8c0,0,0-1.91-4.1-1.83-3.51.07-4.73,2.35-4,4.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.93,41.42s-1,4.33-.07,4.82,5.8.49,5.68-.55-.79-4.7-.79-4.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M42.81,39.1s.79,3.23-.79,3.35-10.56.06-10.81-.18a4.31,4.31,0,0,1-.54-.85L39,39.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.92-1.24s2.18,5.19,3,23.16c.21,4.78-.36,3.66,2,19l-2.83,1.47a2.65,2.65,0,0,1-2.6-.08l-2.75-1.66s1.34-17.21-3-27.1c0,0-2.32,4.28-2.32,7.45s.12,18.42.12,18.42a40.28,40.28,0,0,1-7.44.61S37.5,7,39-.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#eaf3f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.5-3.43a1.93,1.93,0,0,1,.42,2.19S45.23,1.65,39-.82a2,2,0,0,1,.19-2.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#be7855"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.21-33.09l.14,1s.37,6.46-1.74,8.19c0,0-.45,1.33.28,2s8,4.3,8,4.3,1.88,3.89,1.83,6.09c0,0,1.79-.69,1.61-1.56s-1.24-3.15-.92-4.25a1.21,1.21,0,0,1,1.51-.78s.6.64-.37,1.05l.33,1.37,3.89,2.29-.88,1.05s0,8.06-4.8,9.11c0,0-2.51.18-5.49-5.49,0,0-1.6,2.84-1.05,5.31a16.21,16.21,0,0,1-12.36.36L39.06-8S38-.41,34.21-1.15c0,0-10.4-4-8.67-5.52,4-3.54,8.89-.55,8.89-.55.24-5.14.67-11.78,1.34-12.5,1.09-1.19,4.48-.55,5.15-2.08s.49-4.21-.24-7.32,3-5.31,3-5.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.35-32.08a12.57,12.57,0,0,1-6.66-.21l-1.28,3.17h-.74s-1.76-5.87.58-5.8c0,0,0-1.91,4.1-1.83,3.52.07,4.74,2.35,4,4.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.43-29.63c-.31-.75.2-.95.2-.95a32.84,32.84,0,0,1,4.14-2c.71.06,1.59,1.31,1.59,2.38a5.73,5.73,0,0,0,4.25,4.53s-3.57,4.85-8.53,4.18a18.68,18.68,0,0,0-1.65-8.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#eaf3f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8.24-6.91a2.06,2.06,0,0,0-2,2.12V19.45c0,5.86,2.75,26.36,22,32.22,19.22-5.86,22-26.37,22-32.22V-4.79a2.06,2.06,0,0,0-2-2.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.71,19.45V-4.79a2.06,2.06,0,0,0-2-2.12h-20v20.5L31.05,32.9a40.68,40.68,0,0,0,2.66-13.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-10.23,19.45V-4.79a2.06,2.06,0,0,1,2-2.12h20v20.5L-7.57,32.9a40.68,40.68,0,0,1-2.66-13.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#eaf3f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.22,32.27l5.09,5.38H18l3-3.85-3.46,1.38H6.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.26,25.34l-.78,7.82L0,31.81a24.08,24.08,0,0,1,4.31-6.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "205.22",
    y: "145.23",
    width: "0.52",
    height: "13.32",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "210.05",
    y: "146.36",
    width: "0.52",
    height: "12.2",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "200.41",
    y: "146.36",
    width: "0.52",
    height: "12.2",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.25,34.3H9.73a.44.44,0,0,1-.43-.44V31.92a.44.44,0,0,1,.43-.44h3.52a.44.44,0,0,1,.43.44v1.94a.44.44,0,0,1-.43.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.25,30.55H9.73a.44.44,0,0,1-.43-.44V28.17a.43.43,0,0,1,.43-.43h3.52a.43.43,0,0,1,.43.43v1.94a.44.44,0,0,1-.43.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.25,27.1H9.73a.44.44,0,0,1-.43-.44V24.72a.43.43,0,0,1,.43-.43h3.52a.43.43,0,0,1,.43.43v1.94a.44.44,0,0,1-.43.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.78,34.3H14.85a.44.44,0,0,1-.43-.44V31.92a.44.44,0,0,1,.43-.44h2.93a.44.44,0,0,1,.43.44v1.94a.44.44,0,0,1-.43.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.78,30.84H14.85a.43.43,0,0,1-.43-.43v-1.5a.44.44,0,0,1,.43-.44h2.93a.44.44,0,0,1,.43.44v1.5a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.78,27.43H14.85a.44.44,0,0,1-.43-.44V25.87a.44.44,0,0,1,.43-.44h2.93a.44.44,0,0,1,.43.44V27a.44.44,0,0,1-.43.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.14,34.3H5.21a.44.44,0,0,1-.43-.44V31.92a.44.44,0,0,1,.43-.44H8.14a.44.44,0,0,1,.43.44v1.94a.44.44,0,0,1-.43.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.14,30.84H5.21a.43.43,0,0,1-.43-.43v-1.5a.44.44,0,0,1,.43-.44H8.14a.44.44,0,0,1,.43.44v1.5a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.14,27.43H5.21A.44.44,0,0,1,4.78,27V25.87a.44.44,0,0,1,.43-.44H8.14a.44.44,0,0,1,.43.44V27a.44.44,0,0,1-.43.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.05,23.37v1.57l-2.32-.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.42,23.37v1.57l-2.32-.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.25,22.23v1.58L8.93,23Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.17,37H-5.7A32.56,32.56,0,0,0-4,40H27.44A30.36,30.36,0,0,0,29.17,37Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.44,40H-4a29.56,29.56,0,0,0,5.13,5.86H22.32A29.19,29.19,0,0,0,27.44,40Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.16,45.81a28.46,28.46,0,0,0,10.58,5.86,28.46,28.46,0,0,0,10.58-5.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,15.31a1.08,1.08,0,0,1-.45,0c-.18-.07-.54-.09-.32-.76.11-.34.33-.81.17-.93L7,13.17,5.93,12A37.41,37.41,0,0,0,3.18,9.21L1.55,7.72C1,7.23.44,6.69-.19,6.23A10.75,10.75,0,0,0-1.4,5.81a3.5,3.5,0,0,1-.91-.7l-1.62-1.5C-5,2.66-5.93,1.71-6.74.89S-8.15-.57-8.59-1.06a1.17,1.17,0,0,1,.06-1.62l1.3-1.26a1.16,1.16,0,0,1,1.62,0c.48.46,1.13,1.12,1.88,1.92S-2-.22-1.11.89L.33,2.56A3.41,3.41,0,0,1,1,3.5a10.7,10.7,0,0,0,.38,1.21c.43.65,1,1.2,1.42,1.8L4.23,8.19A38.36,38.36,0,0,0,6.91,11L8.06,12.1l.48.44c.12.17.6,0,.94-.13.68-.2.68.17.75.35a1,1,0,0,1-.07.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#be7855"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-6.37,17.62A1.14,1.14,0,0,1-7,17.41a1.11,1.11,0,0,1-.23-1.54L3.19,1.71A1.1,1.1,0,1,1,5,3L-5.48,17.18a1.14,1.14,0,0,1-.89.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2,.78l5.44,3.6L9.74,1.14,4.68-2.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.43-.61,30.34,16.55s2,.09,1.69-1.47L17.62-1.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.31,1.74S17.23,1,18.87-1.41l2.22,2.62s-3.64,2.58-4,5.38c0,0-3-.8-3.78-4.85Zm0,0",
    transform: "translate(194 123)",
    fill: "#eaf3f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.34.05a.72.72,0,0,1-.63-.38,2.26,2.26,0,0,1-.2-2,2.09,2.09,0,0,1,1.32-1.1.72.72,0,0,1,.86.51.71.71,0,0,1-.5.87.69.69,0,0,0-.39.3A1.09,1.09,0,0,0,29-1a.71.71,0,0,1-.3,1,.64.64,0,0,1-.33.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.91,10.64a.72.72,0,0,0-.38-.63,2.28,2.28,0,0,0-2-.2,2.07,2.07,0,0,0-1.09,1.32.71.71,0,0,0,1.37.37.67.67,0,0,1,.3-.39,1,1,0,0,1,.78.16.71.71,0,0,0,1-.3.76.76,0,0,0,.08-.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.81-1.55,15.71,11.32l3.09,3.44L31.6,1.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#eaf3f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-37.73-20.09a1.06,1.06,0,0,1,.85,1.83c-.79.86-3.08,2.4-3.78,2.26-1.22-.25-2.07-2.93,2.93-4.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe3c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.68-18.86c-.82-.2-1.53,1-.8,1.84s2.86,2.4,3.51,2.25c1.13-.24,1.92-2.93-2.71-4.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.72-6.91a2.06,2.06,0,0,1,2,2.12V19.45c0,5.86-2.75,26.36-22,32.22-19.22-5.86-22-26.37-22-32.22V-4.79a2.06,2.06,0,0,1,2-2.12h40m0-1.47h-40a3.53,3.53,0,0,0-3.45,3.59V19.45A42,42,0,0,0-7.77,36.18,30.61,30.61,0,0,0,11.32,53.07l.42.13.43-.13A30.61,30.61,0,0,0,31.26,36.18a42.14,42.14,0,0,0,3.92-16.73V-4.79a3.54,3.54,0,0,0-3.46-3.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.9,52c-6.22-2.08-12.9-1.12-19.2,3.08-8,5.36-13.38,5.36-15.94,5.36s-7.91,0-15.95-5.36c-6.3-4.2-13-5.16-19.2-3.08v6.28c3.92-1.88,9.45-2.66,16,1.67,9.52,6.35,16.3,6.35,19.2,6.35S21.43,66.31,31,60c6.5-4.34,12-3.55,16-1.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#eaf3f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.76,85.35A74.77,74.77,0,0,1-62.93,10.66,74.77,74.77,0,0,1,11.76-64,74.76,74.76,0,0,1,86.44,10.66,74.77,74.77,0,0,1,11.76,85.35Zm0-146.44A71.84,71.84,0,0,0-60,10.66,71.84,71.84,0,0,0,11.76,82.42,71.84,71.84,0,0,0,83.51,10.66,71.84,71.84,0,0,0,11.76-61.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#965032"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-69.95,16.89s-.3-9.16,8.48-9.16a5.73,5.73,0,0,1-3,5.19,29.77,29.77,0,0,0-5.5,4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-53,16.89s.3-9.16-8.49-9.16a5.74,5.74,0,0,0,3,5.19,29.93,29.93,0,0,1,5.49,4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M93.4,7.73s.3,9.16-8.48,9.16a5.73,5.73,0,0,1,3-5.19,29.93,29.93,0,0,0,5.49-4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M76.43,7.73s-.3,9.16,8.48,9.16a5.74,5.74,0,0,0-3-5.19,29.77,29.77,0,0,1-5.5-4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.3,94s-9.15.31-9.15-8.48a5.76,5.76,0,0,1,5.19,3,29.69,29.69,0,0,0,4,5.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.3,77s-9.15-.31-9.15,8.48a5.76,5.76,0,0,0,5.19-3,30.09,30.09,0,0,1,4-5.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.15-69.36s9.15-.31,9.15,8.48a5.74,5.74,0,0,1-5.18-3,30.44,30.44,0,0,0-4-5.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.15-52.4s9.15.31,9.15-8.48a5.74,5.74,0,0,0-5.18,3,30,30,0,0,1-4,5.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-42.79,73.3s-6.69-6.26-.48-12.47a5.74,5.74,0,0,1,1.56,5.78,29.8,29.8,0,0,0-1.08,6.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-30.79,61.3s-6.26-6.69-12.47-.47a5.75,5.75,0,0,0,5.78,1.55,29.8,29.8,0,0,1,6.69-1.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M66.24-48.68s6.69,6.26.47,12.47A5.74,5.74,0,0,1,65.16-42a29.8,29.8,0,0,0,1.08-6.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.25-36.68S60.5-30,66.71-36.2a5.73,5.73,0,0,0-5.78-1.56,29.75,29.75,0,0,1-6.68,1.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M72.71,66.83s-6.25,6.69-12.46.47A5.74,5.74,0,0,1,66,65.75a29.75,29.75,0,0,0,6.68,1.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.72,54.83S54,61.09,60.24,67.3a5.74,5.74,0,0,0,1.56-5.78,29.8,29.8,0,0,1-1.08-6.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-49.26-42.2s6.26-6.69,12.47-.48a5.74,5.74,0,0,1-5.78,1.56,29.8,29.8,0,0,0-6.69-1.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-37.27-30.21s6.69-6.26.48-12.47a5.75,5.75,0,0,0-1.55,5.78,30.16,30.16,0,0,1,1.07,6.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-62,47.79s-3.78-8.33,4.33-11.7A5.75,5.75,0,0,1-58.42,42,29.84,29.84,0,0,0-62,47.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-46.31,41.3s-3.21-8.57-11.33-5.21a5.74,5.74,0,0,0,4.74,3.65,29.81,29.81,0,0,1,6.59,1.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85.43-23.17s3.78,8.34-4.33,11.7a5.74,5.74,0,0,1,.78-5.94,30.13,30.13,0,0,0,3.55-5.76Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M69.76-16.68S73-8.11,81.09-11.47a5.74,5.74,0,0,0-4.74-3.65,29.81,29.81,0,0,1-6.59-1.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.21,86s-8.34,3.79-11.7-4.33a5.74,5.74,0,0,1,5.93.78A29.83,29.83,0,0,0,47.21,86Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.71,70.34s-8.57,3.22-5.2,11.34a5.74,5.74,0,0,0,3.64-4.75,30.43,30.43,0,0,1,1.56-6.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23.76-61.4s8.34-3.78,11.7,4.34A5.72,5.72,0,0,1-18-57.84a30.11,30.11,0,0,0-5.77-3.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.27-45.72s8.58-3.22,5.21-11.34a5.74,5.74,0,0,0-3.64,4.75,30.19,30.19,0,0,1-1.57,6.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-15.3,89.52s-8.57-3.22-5.21-11.34a5.74,5.74,0,0,1,3.65,4.75,29.81,29.81,0,0,0,1.56,6.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8.81,73.84s-8.34-3.78-11.7,4.34a5.74,5.74,0,0,0,5.94-.78,29.84,29.84,0,0,1,5.76-3.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.75-64.9S47.32-61.68,44-53.56a5.74,5.74,0,0,1-3.64-4.75,30.36,30.36,0,0,0-1.57-6.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.26-49.22S40.6-45.44,44-53.56a5.74,5.74,0,0,0-5.93.78,30.11,30.11,0,0,1-5.77,3.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M88.93,39.34s-3.22,8.57-11.34,5.21a5.74,5.74,0,0,1,4.75-3.65,29.81,29.81,0,0,0,6.59-1.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.26,32.85s-3.78,8.34,4.33,11.7a5.75,5.75,0,0,0-.77-5.94,29.84,29.84,0,0,1-3.56-5.76Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.48-14.72s3.22-8.57,11.34-5.21a5.74,5.74,0,0,1-4.75,3.65,30.43,30.43,0,0,0-6.59,1.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-49.81-8.22s3.79-8.34-4.33-11.71A5.74,5.74,0,0,0-53.36-14a29.83,29.83,0,0,1,3.55,5.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-67.48,32.73s-2.09-8.91,6.53-10.63a5.75,5.75,0,0,1-1.92,5.67,29.77,29.77,0,0,0-4.61,5Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-50.84,29.43s-1.49-9-10.11-7.33a5.72,5.72,0,0,0,4,4.5,30,30,0,0,1,6.16,2.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90.94-8.11S93,.8,84.4,2.52a5.75,5.75,0,0,1,1.92-5.67,30,30,0,0,0,4.62-5Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M74.3-4.8s1.49,9,10.1,7.32A5.74,5.74,0,0,0,80.46-2,30,30,0,0,1,74.3-4.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.15,91.52S23.23,93.6,21.52,85a5.75,5.75,0,0,1,5.67,1.92,29.36,29.36,0,0,0,5,4.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.84,74.88s-9,1.49-7.32,10.11A5.76,5.76,0,0,0,26,81a30.25,30.25,0,0,1,2.82-6.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8.7-66.9S.22-69,1.94-60.37a5.75,5.75,0,0,1-5.67-1.92,29.66,29.66,0,0,0-5-4.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5.39-50.26s9-1.49,7.33-10.1a5.75,5.75,0,0,0-4.51,3.94,29.4,29.4,0,0,1-2.82,6.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-29.84,82.76s-7.79-4.83-2.9-12.14A5.75,5.75,0,0,1-30.09,76a29.77,29.77,0,0,0,.25,6.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.42,68.66s-7.44-5.34-12.32,2a5.75,5.75,0,0,0,6,.4,30.07,30.07,0,0,1,6.35-2.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M53.3-58.14S61.07-53.31,56.19-46a5.75,5.75,0,0,1-2.65-5.37,30,30,0,0,0-.24-6.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.87-44s7.44,5.34,12.32-2a5.75,5.75,0,0,0-6-.4A29.87,29.87,0,0,1,43.87-44Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M82.18,53.88S77.35,61.66,70,56.78a5.73,5.73,0,0,1,5.37-2.65,29.82,29.82,0,0,0,6.77-.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M68.07,44.46s-5.34,7.44,2,12.32a5.75,5.75,0,0,0,.39-6,29.87,29.87,0,0,1-2.36-6.34Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-58.73-29.26s4.83-7.78,12.14-2.9A5.75,5.75,0,0,1-52-29.5a30.08,30.08,0,0,0-6.77.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-44.62-19.83s5.34-7.44-2-12.33a5.75,5.75,0,0,0-.39,6,29.87,29.87,0,0,1,2.36,6.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-53.64,61.49s-5.34-7.44,2-12.32a5.73,5.73,0,0,1,.39,6,30.07,30.07,0,0,0-2.36,6.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-39.54,52.07s-4.82-7.79-12.13-2.9a5.75,5.75,0,0,0,5.36,2.65,29.77,29.77,0,0,1,6.77.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M77.09-36.87s5.34,7.44-2,12.32a5.73,5.73,0,0,1-.39-6,29.87,29.87,0,0,0,2.36-6.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M63-27.44s4.83,7.78,12.13,2.9a5.75,5.75,0,0,0-5.36-2.66A30,30,0,0,1,63-27.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.91,77.68s-7.45,5.33-12.32-2a5.73,5.73,0,0,1,6-.39,30.49,30.49,0,0,0,6.35,2.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.48,63.57s-7.78,4.83-2.9,12.14a5.73,5.73,0,0,0,2.65-5.37,30.47,30.47,0,0,1,.25-6.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-37.45-53.06s7.44-5.34,12.32,2a5.76,5.76,0,0,1-6,.4,30.15,30.15,0,0,0-6.34-2.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-28-38.95s7.78-4.83,2.9-12.14a5.73,5.73,0,0,0-2.65,5.37A29.77,29.77,0,0,1-28-38.95Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.28,93.31S-8.75,91.82-7,83.2a5.75,5.75,0,0,1,4.5,4A30.25,30.25,0,0,0,.28,93.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.59,76.67S-5.33,74.58-7,83.2a5.75,5.75,0,0,0,5.67-1.92,29.77,29.77,0,0,1,5-4.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.17-68.68s9,1.48,7.32,10.1A5.74,5.74,0,0,1,26-62.52a30,30,0,0,0-2.82-6.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.86-52S28.78-50,30.49-58.58a5.75,5.75,0,0,0-5.67,1.92,29.36,29.36,0,0,1-5,4.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.72,23.76s-1.49,9-10.1,7.32a5.75,5.75,0,0,1,3.94-4.51,29.59,29.59,0,0,0,6.16-2.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M76.09,20.45S74,29.36,82.62,31.08a5.75,5.75,0,0,0-1.92-5.67,29.77,29.77,0,0,1-4.61-5Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-69.27.87s1.48-9,10.1-7.33a5.75,5.75,0,0,1-3.94,4.51A29.4,29.4,0,0,0-69.27.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-52.63,4.18s2.08-8.92-6.53-10.64A5.72,5.72,0,0,0-57.24-.79a30.14,30.14,0,0,1,4.61,5Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagBZ;
exports["default"] = _default;